import { getFooterApi } from "../../api/home/footerApi";
import {
  // GET_FOOTER_SUCCESS,
  // GET_FOOTER_FAILURE,
  GET_HOMEPAGE_SUCCESS,
  GET_HOMEPAGE_FAILURE,
} from "../types";

export const getFooterSuccess = (homepage) => ({
  type: GET_HOMEPAGE_SUCCESS,
  // type: GET_FOOTER_SUCCESS,
  payload: homepage,
});

export const getFooterFailure = (error) => ({
  type: GET_HOMEPAGE_FAILURE,
  // type: GET_FOOTER_FAILURE,
  payload: error,
});

export const getFooter = (postData) => {
  return (dispatch) => {
    getFooterApi(postData)
      .then((response) => {
        dispatch(getFooterSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getFooterFailure(error.message));
      });
  };
};
